/**
 * URL safety helpers used when rendering links sourced from backend metadata
 * (citation links, document `webViewLink`, Confluence `source_web_link`, etc.).
 *
 * These callers all want the same contract: only allow https URLs so that a
 * poisoned metadata field cannot inject `javascript:`, `data:` or other
 * dangerous schemes into a clickable `href`.
 *
 * NOTE: `useIntegrationOAuth.ts` intentionally allows both http and https
 * for OAuth `auth_url` redirects (some local providers issue http). Keep that
 * variant inline rather than reusing this helper.
 */
export const isSafeUrl = (url: string | undefined | null): boolean => {
  if (!url) return false;
  try {
    return new URL(url).protocol === "https:";
  } catch {
    return false;
  }
};
